import { render, staticRenderFns } from "./Carrier.vue?vue&type=template&id=6ff84bfe&scoped=true"
import script from "./Carrier.vue?vue&type=script&lang=js"
export * from "./Carrier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff84bfe",
  null
  
)

export default component.exports